import classNames from 'classnames';
import * as dateFnsCompat from 'utils/date-fns-compat';

import he from 'he';
import fp from 'lodash/fp';
import prettyBytes from 'pretty-bytes';
import queryString from 'query-string';
import React from 'react';
import { Button, Col, Grid, Row, Tab, Tabs } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { goBack, push } from 'react-router-redux';
import {
  branch,
  compose,
  defaultProps,
  lifecycle,
  renderComponent,
  withHandlers,
  withProps,
  withStateHandlers
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  cpdPointStatus,
  dateFormats,
  PublishedEventTypes,
  routes,
  tabKeys,
  accreditationNames,
  cpdCategoryType
} from '../../../../constants';
import { externalActivityType } from '../../../../constants/content-type';
import { modeOfLearning } from '../../../../constants/mode-of-learning';
import { typeOfCpd } from '../../../../constants/type-of-cpd';
import {
  attachFullNameAndRemoveParent,
  decodeNotes,
  encodeNotes,
  fullName,
  getUserIndustryGoals,
  handleInvalidForm,
  isBusinessAdmin,
  isBusinessUser,
  isExternalBusinessUser,
  isManager,
  isTeamManager,
  isNonEmptyString,
  isNonEmptyNumber
} from '../../../../services';
import {
  businessActions,
  businessSelector,
  externalCpdForReviewSelector,
  isFetchingExternalCpdForReviewSelector,
  queryTeamMembersSelector
} from '../../../../state/modules/business';
import { contentConfigSelector } from '../../../../state/modules/configuration/selectors';
import { eventActions } from '../../../../state/modules/event';
import {
  externalCpdActions,
  externalCpdForEditSelector,
  isFetchingExternalCpdForEditSelector
} from '../../../../state/modules/external-cpd';
import { publisherActions } from '../../../../state/modules/publisher';
import {
  currentUserIndustry,
  currentUserSelector
} from '../../../../state/modules/user';
import {
  branchFuncs,
  noCapMap,
  noCapMapValues,
  noCapRemove,
  reargCurriedConcat,
  spreadArgs,
  toBoolean,
  _
} from '../../../../utils';
import {
  ConfirmationModal,
  ControlGroup,
  ControlOption,
  DateFormField,
  FileUploadFormField,
  FormField,
  FormSubmissionMessage,
  Icon,
  InputFormField,
  NumberFormField,
  SelectFormField,
  TextAreaFormField,
  TeamUserSelector
} from '../../../components';
import { followedBy } from '../../../components/higher-order';
import Loading from '../../loading';
import { workflow } from './workflowConfig';
import { format } from 'date-fns';
import { syncCpdCategoryWithGoals } from '../../shared/syncCpdCategoryWithGoals';
import { filterNonLegacyOrPublisherVisible } from '../../../../common/cpd-category-filter';

const formHandler = (handler, stateTransition, formRef) => (e) => {
  e.preventDefault();
  e.stopPropagation();
  handler(stateTransition);
  handleInvalidForm(formRef);
};

const notesEventHandler = (handler) => (e) =>
  handler(e.target.name, encodeNotes(e.target.value));
const eventHandler = (handler) => (e) => handler(e.target.name, e.target.value);
const numberEventHandler = (handler) =>
  eventHandler((name, value) => handler(name, parseInt(value, 10)));
const fileDropHandler = (handler) => (key) => (accepted, rejected) =>
  fp.flow(
    fp.map(fp.head),
    branchFuncs(
      fp.head,
      fp.flow(() => handler(key, accepted)),
      fp.flow(
        fp.get('[1]'),
        branchFuncs(
          fp.identity,
          () => handler(key, [{ invalid: true }]),
          fp.identity
        )
      )
    )
  )([accepted, rejected]);
const goalHandler = (handler) => (goalToToggle, goals) => {
  const goalSelected = fp.includes(goalToToggle)(goals);
  const updatedGoals = goalSelected
    ? fp.filter((goal) => goal !== goalToToggle)(goals)
    : goals.concat(goalToToggle);
  handler('goals', updatedGoals);
};

const validateAccreditationName = (name) => {
  if (!isNonEmptyString(name)) {
    return 'Accreditation Number is required';
  }
};

const validatePoints = (points) => {
  if (!isNonEmptyNumber(points) || points <= 0) {
    return 'Must be more than 0';
  }
};

const validateAccreditationNumber = (AccreditationNumber) => {
  if (!isNonEmptyString(AccreditationNumber)) {
    return 'Accreditation Number is required';
  }

  if (!/^[A-Za-z0-9]*$/.test(AccreditationNumber)) {
    return 'Only letters and numbers are allowed';
  }
};

const CreateModal = compose(
  withProps(
    ({ currentUser, users, contentType, stateTransition, reviewUserName }) => ({
      headingText: (
        <span>
          {stateTransition ? stateTransition.confirmation.heading : ''}
        </span>
      ),
      message: (
        <div>
          <p key={0}>
            {stateTransition
              ? stateTransition.confirmation.header({ contentType })
              : ''}
          </p>
          <p key={1}>
            {stateTransition
              ? stateTransition.confirmation.body({
                  users,
                  reviewUserName,
                  contentType
                })
              : ''}
          </p>
        </div>
      ),
      confirmLabel: stateTransition
        ? stateTransition.confirmation.confirmLabel
        : '',
      cancelLabel: stateTransition
        ? stateTransition.confirmation.cancelLabel
        : ''
    })
  )
)(
  ({
    headingText,
    message,
    onCancel,
    onConfirm,
    showConfirmation,
    currentUser,
    stateTransition,
    show,
    confirmLabel,
    cancelLabel,
    isLoading
  }) => (
    <ConfirmationModal
      {...{
        key: 0,
        show,
        isLoading,
        actions: [
          {
            onConfirmAction: (reasonText) =>
              onConfirm(stateTransition, reasonText),
            actionLabel: confirmLabel,
            actionClass: stateTransition ? stateTransition.className : ''
          }
        ],
        cancel: onCancel,
        reason: stateTransition ? stateTransition.confirmation.reason : false,
        message,
        headingText,
        cancelLabel: cancelLabel
      }}
    />
  )
);

const ExternalCpdHistoryTable = ({ history, rejectedText }) => {
  return !history || (history && history.length === 0) ? (
    <h2>No history available</h2>
  ) : (
    <table className='table--externalCpdHistory'>
      <thead>
        <tr>
          <td className='action-time'>When</td>
          <td className='username'>Who</td>
          <td className='action'>Action</td>
          <td className='status'>Status</td>
          <td className='notes'>Comments</td>
        </tr>
      </thead>
      <tbody>
        {history &&
          history.map((item, index) => (
            <tr key={index}>
              <td className='action-time'>
                {dateFnsCompat.format(
                  item.action_time,
                  dateFormats.ShortDateTime
                )}
              </td>
              <td className='username'>{item.userName}</td>
              <td className='action'>{item.action}</td>
              <td className='status'>
                {item.status === cpdPointStatus.draft
                  ? rejectedText
                  : item.status}
              </td>
              <td className='notes'>{he.decode(item.notes)}</td>
            </tr>
          ))}
      </tbody>
    </table>
  );
};

const ExternalCpdDetails = ({
  addArrayValue,
  cpdCategorys: userCpdCategorys,
  config,
  details,
  externalCpd: { files: savedFiles, existingFiles },
  getValidation,
  isCreate,
  isLoading,
  removeArrayValue,
  setDetail,
  submitForm,
  searchUsers,
  onUserSelected,
  currentUser,
  teamSearchText,
  teamMembers,
  reviewUserName,
  goTo,
  goBack,
  workflowButtons,
  isTeamReview,
  readOnlyForm,
  showSubmissionMessage,
  error,
  stopFocusingMessage,
  hideSubmissionMessage,
  focusMessage,
  externalCpdHistory,
  toggleDropdownOpen,
  isDropdownOpen,
  selectDropDown,
  dropDownSelectedKey,
  formRef,
  setFormRef,
  eventInvalid,
  addFiles,
  backRoute,
  inEditMode,
  toggleEditMode,
  workflowUser,
  industryCpdCategorys,
  industriesWithCpdCategorys,
  profile,
  business,
  submitted
}) => {
  const recordForTeam =
    isBusinessAdmin(currentUser) ||
    isManager(currentUser) ||
    isTeamManager(currentUser, business);

  const userCoreCpdCategorys = fp.flow(
    fp.filter((category) => category.categoryType === cpdCategoryType.core),
    fp.uniqBy((userCpdCategory) => userCpdCategory.id)
  )(userCpdCategorys);

  const userSubCpdCategorys = fp.flow(
    fp.filter((category) => category.categoryType === cpdCategoryType.sub),
    fp.uniqBy((userCpdCategory) => userCpdCategory.id)
  )(userCpdCategorys);

  const userInFormCoreCpdCategorys = fp.flow(
    fp.get('cpdCategorys'),
    fp.filter(({ cpdCategoryId }) =>
      fp.contains(cpdCategoryId)(fp.map('id')(industryCpdCategorys))
    ),
    fp.filter(({ cpdCategoryId }) =>
      fp.contains(cpdCategoryId)(fp.map('id')(userCoreCpdCategorys))
    )
  )(details);

  const userInFormSubCpdCategorys = fp.flow(
    fp.get('cpdCategorys'),
    fp.filter(({ cpdCategoryId }) =>
      fp.contains(cpdCategoryId)(fp.map('id')(industryCpdCategorys))
    ),
    fp.filter(({ cpdCategoryId }) =>
      fp.contains(cpdCategoryId)(fp.map('id')(userSubCpdCategorys))
    )
  )(details);

  const userInFormAccreditationDetails =
    details.additionalData.accreditationDetails;

  const getDetail = (key) => fp.get(key)(details);

  return (
    <Grid>
      <h1 className='text-center'>
        <Icon icon='external-cpd-large' />
        {isTeamReview
          ? ` External CPD for ${reviewUserName}`
          : recordForTeam && isCreate
            ? ' Record external CPD for myself or my team'
            : ' External CPD'}
      </h1>
      <FormSubmissionMessage
        showSubmissionMessage={showSubmissionMessage}
        submissionMessage={'Your details were successfully updated'}
        error={error}
        focusMessage={focusMessage}
        stopFocusingMessage={stopFocusingMessage}
        hideSubmissionMessage={hideSubmissionMessage}
      />
      <Row className='md-gutter'>
        <Col xs={12} md={8} mdOffset={2} className='boxed text-left'>
          <form noValidate ref={setFormRef}>
            <Tabs
              defaultActiveKey={dropDownSelectedKey}
              id='external-cpd-screen'
              onSelect={selectDropDown}
              className={classNames(
                'tab-zone',
                'panel-tabs',
                { opened: isDropdownOpen },
                isCreate ? 'hide-tabs' : ''
              )}
            >
              <Tab
                eventKey='detail'
                title={[
                  <span key={0}>Details</span>,
                  <span
                    key={1}
                    className='activeArrow'
                    onClick={toggleDropdownOpen}
                  >
                    <i className='icon-chevron-down-large' />
                  </span>
                ]}
              >
                {recordForTeam ? (
                  <Row>
                    <Col xs={12} className='team-select-input'>
                      {isCreate ? (
                        <TeamUserSelector
                          label='Who is this for?'
                          teamMembers={teamMembers}
                          selected={fp.get('users')(details) || []}
                          searchText={teamSearchText}
                          onSearch={searchUsers}
                          onChange={(updatedUsers) =>
                            setDetail('users', updatedUsers)
                          }
                          validation={getValidation('users')}
                          currentUser={currentUser}
                        />
                      ) : null}
                    </Col>
                  </Row>
                ) : null}
                <Row>
                  <Col xs={12}>
                    <InputFormField
                      {...{
                        id: 'activityName',
                        onChange: eventHandler(setDetail),
                        required: true,
                        disabled: readOnlyForm,
                        validation: getValidation('activityName'),
                        value: fp.get('activityName')(details)
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <InputFormField
                      {...{
                        id: 'providerName',
                        onChange: eventHandler(setDetail),
                        required: true,
                        disabled: readOnlyForm,
                        validation: getValidation('providerName'),
                        value: fp.get('providerName')(details)
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  {fp.get('description')(details) === '' &&
                  readOnlyForm ? null : (
                    <Col xs={12}>
                      {/* <InputFormField {...{
                        id: 'link',
                        name: 'link',
                        label: 'URL',
                        onChange: eventHandler(setDetail),
                        disabled: readOnlyForm,
                        value: fp.get('link')(details)
                      }} /> */}
                      <TextAreaFormField
                        {...{
                          id: 'description',
                          label: 'Description (optional)',
                          inputProps: { disabled: readOnlyForm },
                          onChange: eventHandler(setDetail),
                          value: he.decode(fp.get('description')(details))
                        }}
                      />
                    </Col>
                  )}
                </Row>
                {
                  // Hide the component for now for future reference as Sasha suggested.
                  false && (
                    <Row>
                      <Col xs={12}>
                        <InputFormField
                          {...{
                            id: 'accreditationNumber',
                            label: 'Accreditation Number (if applicable)',
                            onChange: eventHandler(setDetail),
                            disabled: readOnlyForm,
                            validation: getValidation('accreditationNumber'),
                            value: fp.get('accreditationNumber')(details)
                          }}
                        />
                      </Col>
                    </Row>
                  )
                }
                <Row>
                  <Col xs={9}>
                    <p className='strong'>Accreditation Details</p>
                  </Col>
                  {userInFormAccreditationDetails.map(
                    ({ name, number, points }, index) => {
                      const nameKey =
                        _.invert(accreditationNames)[name] || 'Other';
                      return (
                        <Col xs={12} key={index}>
                          <Row className='xs-gutter'>
                            <Col xs={6}>
                              <SelectFormField
                                formGroupProps={{ className: 'clearfix' }}
                                id={`accreditation-${index}`}
                                name={`additionalData.accreditationDetails[${index}].name`}
                                label='Accreditation'
                                onChange={(e) => {
                                  if (e.target.value === 'Other') {
                                    setDetail(e.target.name, '');
                                  } else {
                                    setDetail(
                                      e.target.name,
                                      accreditationNames[e.target.value]
                                    );
                                  }
                                }}
                                emptyOption={false}
                                required
                                disabled={readOnlyForm}
                                value={nameKey}
                              >
                                {fp.flow(
                                  fp.keys,
                                  fp.filter(
                                    (key) =>
                                      !fp.contains(accreditationNames[key])(
                                        fp.map('name')(
                                          userInFormAccreditationDetails
                                        )
                                      ) || key === nameKey
                                  ),
                                  fp.map((key) => (
                                    <option key={key} value={key}>
                                      {he.decode(accreditationNames[key])}
                                    </option>
                                  ))
                                )(accreditationNames)}
                              </SelectFormField>
                            </Col>
                            {nameKey === 'Other' && (
                              <Col xs={6}>
                                <InputFormField
                                  id={`accreditation-name-input-${index}`}
                                  label='Name'
                                  name={`additionalData.accreditationDetails[${index}].name`}
                                  required={true}
                                  disabled={readOnlyForm}
                                  value={name}
                                  onChange={(e) => {
                                    eventHandler(setDetail)(e);
                                  }}
                                  validation={
                                    !submitted
                                      ? undefined
                                      : validateAccreditationName(
                                          getDetail(
                                            `additionalData.accreditationDetails[${index}].name`
                                          )
                                        )
                                  }
                                />
                              </Col>
                            )}
                          </Row>
                          <Row className='xs-gutter'>
                            <Col xs={!readOnlyForm ? 8 : 9}>
                              <InputFormField
                                id={`accreditation-number-input-${index}`}
                                label='Number'
                                name={`additionalData.accreditationDetails[${index}].number`}
                                required={true}
                                disabled={readOnlyForm}
                                value={number}
                                onChange={(e) => {
                                  eventHandler(setDetail)(e);
                                }}
                                validation={
                                  !submitted
                                    ? undefined
                                    : validateAccreditationNumber(
                                        getDetail(
                                          `additionalData.accreditationDetails[${index}].number`
                                        )
                                      )
                                }
                              />
                            </Col>
                            <Col xs={2}>
                              <NumberFormField
                                {...{
                                  id: `accreditation-points-${index}`,
                                  label: 'Hours',
                                  min: 0,
                                  step: 0.25,
                                  disabled: readOnlyForm,
                                  inputProps: { disabled: readOnlyForm },
                                  onChange: (e) => {
                                    setDetail(
                                      `additionalData.accreditationDetails[${index}].points`,
                                      e.value
                                    );
                                  },
                                  required: true,
                                  value: points,
                                  validation: !submitted
                                    ? undefined
                                    : validatePoints(
                                        getDetail(
                                          `additionalData.accreditationDetails[${index}].points`
                                        )
                                      )
                                }}
                              />
                            </Col>
                            {!readOnlyForm ? (
                              <Col xs={1}>
                                <Button
                                  bsStyle='plain'
                                  disabled={readOnlyForm}
                                  className='large area-of-advice-remove pull-right'
                                  onClick={() =>
                                    removeArrayValue(
                                      'additionalData.accreditationDetails',
                                      index
                                    )
                                  }
                                >
                                  <Icon icon='close-thick' />
                                </Button>
                              </Col>
                            ) : null}
                          </Row>
                        </Col>
                      );
                    }
                  )}
                  <Col xs={12} className='flex-center'>
                    {!readOnlyForm ? (
                      <Button
                        onClick={() => {
                          const toAddAccreditationNameKey = fp.flow(
                            fp.keys,
                            fp.filter(
                              (key) =>
                                !fp.contains(accreditationNames[key])(
                                  fp.map('name')(userInFormAccreditationDetails)
                                ) && key !== 'Other'
                            ),
                            fp.first
                          )(accreditationNames);
                          const toAddAccreditationName =
                            accreditationNames[toAddAccreditationNameKey];
                          const toAddAccreditationDetails = {
                            name: toAddAccreditationName || '',
                            points: 0,
                            number: ''
                          };
                          addArrayValue(
                            'additionalData.accreditationDetails',
                            toAddAccreditationDetails
                          );
                        }}
                        disabled={readOnlyForm}
                        className='mt-3'
                        style={{ marginBottom: 30 }}
                      >
                        <Icon icon='add-large' /> Add Accreditation Details
                      </Button>
                    ) : null}
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <ControlGroup
                      id='modeOfLearning'
                      label='Mode Of Learning'
                      control='radio'
                      type='styled'
                      validation={getValidation('modeOfLearning')}
                      onChange={eventHandler(setDetail)}
                      colProps={{ xs: 12, sm: 4 }}
                    >
                      {fp.map((type) => (
                        <ControlOption
                          key={type}
                          value={type}
                          disabled={readOnlyForm}
                          label={<span>{fp.startCase(type)}</span>}
                          checked={fp.get('modeOfLearning')(details) === type}
                        />
                      ))(modeOfLearning)}
                    </ControlGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <ControlGroup
                      id='typeOfCpd'
                      label='Type of CPD'
                      control='radio'
                      type='styled'
                      validation={getValidation('typeOfCpd')}
                      onChange={eventHandler(setDetail)}
                      colProps={{ xs: 12, sm: 6 }}
                    >
                      {fp.map(({ key, description }) => (
                        <ControlOption
                          key={key}
                          value={key}
                          disabled={readOnlyForm}
                          label={
                            <span>
                              <div>{fp.startCase(key)}</div>
                              <div className='text-sm'>{description}</div>
                            </span>
                          }
                          checked={fp.get('typeOfCpd')(details) === key}
                        />
                      ))(fp.values(typeOfCpd))}
                    </ControlGroup>
                  </Col>
                </Row>
                {/* hide activity type for now */}
                {/* <Row>
                  <Col xs={12}>
                    <ControlGroup
                      id='contentType'
                      label='Activity Type'
                      control='radio'
                      type='styled'
                      validation={getValidation('contentType')}
                      onChange={eventHandler(setDetail)}
                      colProps={{ xs: 12, sm: 6 }}>
                      {
                        fp.map((type) =>
                          <ControlOption
                            key={type}
                            value={type}
                            disabled={readOnlyForm}
                            label={<span>{fp.startCase(type)}</span>}
                            checked={fp.get('contentType')(details) === type}
                          />
                        )(externalActivityType)
                      }
                    </ControlGroup>
                  </Col>
                </Row> */}
                <Row>
                  <Col xs={12}>
                    <DateFormField
                      {...{
                        id: 'timeEarned',
                        label: 'Date Earned',
                        onChange: (date) => {
                          if (date !== undefined) {
                            setDetail(
                              'timeEarned',
                              format(date, dateFormats.FilteringDate)
                            );
                          }
                        },
                        required: true,
                        disabled: readOnlyForm,
                        validation: getValidation('timeEarned'),
                        dateProps: {
                          minYear: new Date().getFullYear() - 7,
                          futureYears: 0
                        },
                        value: fp.flow(
                          fp.get('timeEarned'),
                          branchFuncs(
                            fp.identity,
                            dateFnsCompat.parse,
                            fp.identity
                          )
                        )(details)
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <FormField
                      id='cpdCategorys'
                      label='Allocation of CPD Hours'
                      type={null}
                      disabled={readOnlyForm}
                      validation={
                        fp.flow(
                          fp.get('cpdCategorys'),
                          fp.find(({ untouched }) => untouched)
                        )(details)
                          ? null
                          : getValidation('cpdCategorys')
                      }
                    >
                      <Row className='xs-gutter'>
                        <Col xs={9}>
                          <p className='strong'>Legislated CPD Areas</p>
                        </Col>
                        {fp.flow(
                          noCapMap(({ cpdCategoryId, points, untouched }) => {
                            const index = details.cpdCategorys.findIndex(
                              (category) =>
                                category.cpdCategoryId === cpdCategoryId
                            );
                            return (
                              <Col key={index} xs={12}>
                                <Row className='xs-gutter'>
                                  <Col xs={!readOnlyForm ? 8 : 9}>
                                    <SelectFormField
                                      formGroupProps={{ className: 'clearfix' }}
                                      id={`cpdCategory${index}`}
                                      name={`cpdCategorys[${index}].cpdCategoryId`}
                                      label='CPD Category'
                                      onChange={(e) => {
                                        numberEventHandler(setDetail)(e);
                                        setDetail(
                                          `cpdCategorys[${index}].untouched`,
                                          false
                                        );
                                      }}
                                      emptyOption={false}
                                      required
                                      disabled={readOnlyForm}
                                      value={
                                        cpdCategoryId ? `${cpdCategoryId}` : ''
                                      }
                                      validation={
                                        untouched
                                          ? null
                                          : getValidation(
                                              `cpdCategorys.arrayValues[${index}].cpdCategoryId`
                                            )
                                      }
                                    >
                                      {fp.flow(
                                        filterNonLegacyOrPublisherVisible,
                                        fp.filter(
                                          ({ id }) =>
                                            !fp.contains(id)(
                                              fp.map('cpdCategoryId')(
                                                userInFormCoreCpdCategorys
                                              )
                                            ) || id === cpdCategoryId
                                        ),
                                        fp.sortBy((aoa) => aoa.name),
                                        fp.map(
                                          ({
                                            id,
                                            name,
                                            legacy,
                                            publisherVisible
                                          }) => (
                                            <option
                                              key={id}
                                              value={id}
                                              className={classNames({
                                                hidden:
                                                  legacy &&
                                                  !publisherVisible &&
                                                  id !== cpdCategoryId
                                              })}
                                            >
                                              {he.decode(name)}
                                            </option>
                                          )
                                        )
                                      )(userCoreCpdCategorys)}
                                    </SelectFormField>
                                  </Col>
                                  <Col xs={2}>
                                    <NumberFormField
                                      {...{
                                        id: `points${index}`,
                                        label: 'CPD Hours',
                                        min: 0,
                                        step: 0.25,
                                        disabled: readOnlyForm,
                                        inputProps: { disabled: readOnlyForm },
                                        onChange: (e) => {
                                          setDetail(
                                            `cpdCategorys[${index}].points`,
                                            e.value
                                          );
                                          setDetail(
                                            `cpdCategorys[${index}].untouched`,
                                            false
                                          );
                                        },
                                        required: true,
                                        value: points,
                                        validation: untouched
                                          ? null
                                          : getValidation(
                                              `cpdCategorys.arrayValues[${index}].points`
                                            )
                                      }}
                                    />
                                  </Col>
                                  {!readOnlyForm &&
                                  userCpdCategorys.length > 1 ? (
                                    <Col xs={1}>
                                      <Button
                                        bsStyle='plain'
                                        disabled={readOnlyForm}
                                        className='large area-of-advice-remove pull-right'
                                        onClick={() =>
                                          removeArrayValue(
                                            'cpdCategorys',
                                            index
                                          )
                                        }
                                      >
                                        <Icon icon='close-thick' />
                                      </Button>
                                    </Col>
                                  ) : null}
                                </Row>
                              </Col>
                            );
                          })
                        )(userInFormCoreCpdCategorys)}
                        <Col xs={12} className='flex-center'>
                          {!readOnlyForm &&
                          userCpdCategorys.length > 1 &&
                          userInFormCoreCpdCategorys.length <
                            userCoreCpdCategorys.length ? (
                            <Button
                              onClick={() => {
                                const toAddCpdCategory = fp.flow(
                                  filterNonLegacyOrPublisherVisible,
                                  fp.filter(
                                    ({ id }) =>
                                      !fp.contains(id)(
                                        fp.map('cpdCategoryId')(
                                          userInFormCoreCpdCategorys
                                        )
                                      )
                                  ),
                                  fp.sortBy((aoa) => aoa.name),
                                  fp.first
                                )(userCoreCpdCategorys);
                                if (toAddCpdCategory !== undefined) {
                                  const addInFormCpdCategory = {
                                    cpdCategoryId: toAddCpdCategory.id,
                                    points: 0,
                                    isMicroCpd: false,
                                    untouched: true
                                  };
                                  addArrayValue(
                                    'cpdCategorys',
                                    addInFormCpdCategory
                                  );
                                }
                              }}
                              disabled={
                                readOnlyForm &&
                                userInFormCoreCpdCategorys.length >=
                                  userCoreCpdCategorys.length
                              }
                              className='mt-3'
                              style={{ marginBottom: 30 }}
                            >
                              <Icon icon='add-large' /> Add CPD Category
                            </Button>
                          ) : null}
                        </Col>
                        <Col xs={9}>
                          <p className='strong'>
                            Total Activity Hours (Legislated):
                          </p>
                        </Col>
                        <Col xs={3}>
                          <p className='strong'>
                            {fp.flow(
                              fp.map('points'),
                              fp.sum
                            )(userInFormCoreCpdCategorys)}
                          </p>
                        </Col>
                        {userSubCpdCategorys.length > 0 && (
                          <Col xs={9}>
                            <p className='strong' style={{ marginTop: 30 }}>
                              ASIC Knowledge Areas (if applicable)
                            </p>
                          </Col>
                        )}
                        {fp.flow(
                          noCapMap(({ cpdCategoryId, points, untouched }) => {
                            const index = details.cpdCategorys.findIndex(
                              (category) =>
                                category.cpdCategoryId === cpdCategoryId
                            );
                            return (
                              <Col key={index} xs={12}>
                                <Row className='xs-gutter'>
                                  <Col xs={!readOnlyForm ? 8 : 9}>
                                    <SelectFormField
                                      formGroupProps={{ className: 'clearfix' }}
                                      id={`cpdCategory${index}`}
                                      name={`cpdCategorys[${index}].cpdCategoryId`}
                                      label='CPD Category'
                                      onChange={(e) => {
                                        numberEventHandler(setDetail)(e);
                                        setDetail(
                                          `cpdCategorys[${index}].untouched`,
                                          false
                                        );
                                      }}
                                      emptyOption={false}
                                      required
                                      disabled={readOnlyForm}
                                      value={
                                        cpdCategoryId ? `${cpdCategoryId}` : ''
                                      }
                                      validation={
                                        untouched
                                          ? null
                                          : getValidation(
                                              `cpdCategorys.arrayValues[${index}].cpdCategoryId`
                                            )
                                      }
                                    >
                                      {fp.flow(
                                        filterNonLegacyOrPublisherVisible,
                                        fp.filter(
                                          ({ id }) =>
                                            !fp.contains(id)(
                                              fp.map('cpdCategoryId')(
                                                userInFormSubCpdCategorys
                                              )
                                            ) || id === cpdCategoryId
                                        ),
                                        fp.sortBy((aoa) => aoa.name),
                                        fp.map(
                                          ({
                                            id,
                                            originName,
                                            legacy,
                                            publisherVisible
                                          }) => (
                                            <option
                                              key={id}
                                              value={id}
                                              className={classNames({
                                                hidden:
                                                  legacy &&
                                                  !publisherVisible &&
                                                  id !== cpdCategoryId
                                              })}
                                            >
                                              {he.decode(originName)}
                                            </option>
                                          )
                                        )
                                      )(userSubCpdCategorys)}
                                    </SelectFormField>
                                  </Col>
                                  <Col xs={2}>
                                    <NumberFormField
                                      {...{
                                        id: `points${index}`,
                                        label: 'CPD Hours',
                                        min: 0,
                                        step: 0.25,
                                        disabled: readOnlyForm,
                                        inputProps: { disabled: readOnlyForm },
                                        onChange: (e) => {
                                          setDetail(
                                            `cpdCategorys[${index}].points`,
                                            e.value
                                          );
                                          setDetail(
                                            `cpdCategorys[${index}].untouched`,
                                            false
                                          );
                                        },
                                        required: true,
                                        value: points,
                                        validation: untouched
                                          ? null
                                          : getValidation(
                                              `cpdCategorys.arrayValues[${index}].points`
                                            )
                                      }}
                                    />
                                  </Col>
                                  {!readOnlyForm &&
                                  userCpdCategorys.length > 1 ? (
                                    <Col xs={1}>
                                      <Button
                                        bsStyle='plain'
                                        disabled={readOnlyForm}
                                        className='large area-of-advice-remove pull-right'
                                        onClick={() =>
                                          removeArrayValue(
                                            'cpdCategorys',
                                            index
                                          )
                                        }
                                      >
                                        <Icon icon='close-thick' />
                                      </Button>
                                    </Col>
                                  ) : null}
                                </Row>
                              </Col>
                            );
                          })
                        )(userInFormSubCpdCategorys)}
                        <Col xs={12} className='flex-center'>
                          {!readOnlyForm &&
                          userSubCpdCategorys.length > 0 &&
                          userInFormSubCpdCategorys.length <
                            userSubCpdCategorys.length ? (
                            <Button
                              onClick={() => {
                                const toAddCpdCategory = fp.flow(
                                  filterNonLegacyOrPublisherVisible,
                                  fp.filter(
                                    ({ id }) =>
                                      !fp.contains(id)(
                                        fp.map('cpdCategoryId')(
                                          userInFormSubCpdCategorys
                                        )
                                      )
                                  ),
                                  fp.sortBy((aoa) => aoa.name),
                                  fp.first
                                )(userSubCpdCategorys);
                                if (toAddCpdCategory !== undefined) {
                                  const addInFormCpdCategory = {
                                    cpdCategoryId: toAddCpdCategory.id,
                                    points: 0,
                                    isMicroCpd: false,
                                    untouched: true
                                  };
                                  addArrayValue(
                                    'cpdCategorys',
                                    addInFormCpdCategory
                                  );
                                }
                              }}
                              disabled={
                                readOnlyForm &&
                                userInFormSubCpdCategorys.length >=
                                  userSubCpdCategorys.length
                              }
                              className='mt-3'
                              style={{ marginBottom: 30 }}
                            >
                              <Icon icon='add-large' /> Add Sub CPD Category
                            </Button>
                          ) : null}
                        </Col>
                        {userSubCpdCategorys.length > 0 && (
                          <Row className='xs-gutter'>
                            <Col xs={9}>
                              <p className='strong'>
                                Total Activity Hours (ASIC):
                              </p>
                            </Col>
                            <Col xs={3}>
                              <p className='strong'>
                                {fp.flow(
                                  fp.map('points'),
                                  fp.sum
                                )(userInFormSubCpdCategorys)}
                              </p>
                            </Col>
                          </Row>
                        )}
                      </Row>
                    </FormField>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <ControlGroup
                      id='external-cpd-progress-goal'
                      control='checkbox'
                      type='styled'
                      label={
                        <h3 className='no-margin'>Please select if relevant</h3>
                      }
                      onChange={(e) =>
                        goalHandler(setDetail)(
                          parseInt(e.target.value, 10),
                          details.goals
                        )
                      }
                      colProps={{ xs: 12, sm: 4 }}
                    >
                      {fp.flow(
                        fp.map((goal) => (
                          <ControlOption
                            key={goal.id}
                            label={<span>{goal.name}</span>}
                            value={goal.id}
                            disabled={readOnlyForm}
                            checked={fp.includes(goal.id)(details.goals)}
                          />
                        ))
                      )(
                        getUserIndustryGoals(
                          profile,
                          industriesWithCpdCategorys
                        )
                      )}
                    </ControlGroup>
                  </Col>
                </Row>
                <Row>
                  {fp.get('notes')(details) === '' && readOnlyForm ? null : (
                    <Col xs={12}>
                      <TextAreaFormField
                        {...{
                          id: 'notes',
                          inputProps: { disabled: readOnlyForm },
                          onChange: notesEventHandler(setDetail),
                          value: decodeNotes(fp.get('notes')(details))
                        }}
                      />
                    </Col>
                  )}
                </Row>
                <Row>
                  {fp.get('existingFiles')(details) &&
                  fp.get('existingFiles')(details).length === 0 &&
                  readOnlyForm ? null : (
                    <Col xs={12}>
                      <FormField
                        id='files'
                        label='Upload Activity Evidence'
                        disabled={readOnlyForm}
                        type={null}
                      >
                        <Row className='xs-gutter'>
                          {fp.flow(
                            fp.get('existingFiles'),
                            noCapMap((file, index) => (
                              <Col key={index} xs={12}>
                                <Row className='xs-gutter'>
                                  <Col xs={10} xsOffset={1}>
                                    {file.preview ? (
                                      <div className='text-center preview-image existing'>
                                        <img
                                          alt={file.internalFileName}
                                          src={he.decode(file.preview)}
                                        />
                                      </div>
                                    ) : (
                                      <a
                                        href={he.decode(file.link)}
                                        className='flex-center linkBox'
                                        target='_blank'
                                      >
                                        {file.supportingFile.internalFileName}
                                      </a>
                                    )}
                                  </Col>
                                  <Col xs={1}>
                                    {!readOnlyForm ? (
                                      <Button
                                        bsStyle='plain'
                                        className='p-0 existing-file-remove pull-right'
                                        onClick={() =>
                                          removeArrayValue(
                                            'existingFiles',
                                            index
                                          )
                                        }
                                      >
                                        <Icon icon='close-thick' />
                                      </Button>
                                    ) : null}
                                  </Col>
                                </Row>
                              </Col>
                            ))
                          )(details)}
                        </Row>
                        <Row className='xs-gutter'>
                          {fp.flow(
                            fp.get('files'),
                            noCapMap((file, index) => (
                              <Col key={index} xs={12}>
                                <Row className='xs-gutter'>
                                  <Col xs={10} xsOffset={1}>
                                    {file && file.saved && !file.invalid ? (
                                      file.preview ? (
                                        <div className='text-center preview-image existing'>
                                          <img
                                            alt={file.name}
                                            src={he.decode(file.preview)}
                                          />
                                        </div>
                                      ) : (
                                        <div className='flex-center'>
                                          {file.name}
                                        </div>
                                      )
                                    ) : (
                                      <FileUploadFormField
                                        styleName={`file-${index}`}
                                        multiple={true}
                                        onFileDrop={fileDropHandler(addFiles)(
                                          index
                                        )}
                                        file={
                                          !file || !file.invalid ? file : null
                                        }
                                        maxSize={
                                          config
                                            ? config.maxCPDFileSizeBytes
                                            : 0
                                        }
                                        validationMessage={
                                          !file || !file.invalid
                                            ? null
                                            : 'max file size ' +
                                              prettyBytes(
                                                config.maxCPDFileSizeBytes
                                              ) +
                                              '.'
                                        }
                                        dropLabel='Upload file'
                                      />
                                    )}
                                  </Col>
                                  <Col xs={1}>
                                    {!readOnlyForm ? (
                                      <Button
                                        bsStyle='plain'
                                        className='p-0 new-file-remove pull-right'
                                        onClick={() =>
                                          removeArrayValue('files', index)
                                        }
                                      >
                                        <Icon icon='close-thick' />
                                      </Button>
                                    ) : null}
                                  </Col>
                                </Row>
                              </Col>
                            ))
                          )(details)}
                        </Row>
                        <Row>
                          <Col xs={12} className='flex-center'>
                            {!readOnlyForm ? (
                              <Button
                                onClick={() => addArrayValue('files')}
                                className='mt-3'
                              >
                                <Icon icon='add-large' />
                              </Button>
                            ) : null}
                          </Col>
                        </Row>
                      </FormField>
                    </Col>
                  )}
                </Row>
                {/* {
                  !inEditMode && workflowUser === 'BusinessUser' ?
                    <Row className='my-4'>
                      <Col xs={12}>
                        <Button
                          onClick={toggleEditMode}
                          className='flex-center full'>
                          Enter Edit Mode
                          </Button>
                      </Col>
                    </Row> :
                    null
                } */}
                {currentUser.activated ? (
                  fp.flow(
                    fp.filter(
                      ({ checkReadOnly }) =>
                        !(checkReadOnly && (eventInvalid || !inEditMode))
                    ),
                    fp.map((buttonDef) => (
                      <Row key={buttonDef.buttonName} className='my-4'>
                        <Col xs={12}>
                          <Button
                            disabled={isLoading}
                            className={`flex-center ${buttonDef.className}`}
                            type='submit'
                            onClick={formHandler(
                              submitForm,
                              buttonDef,
                              formRef
                            )}
                          >
                            {buttonDef.buttonName}
                          </Button>
                        </Col>
                      </Row>
                    ))
                  )(workflowButtons)
                ) : (
                  <Row key='reactivate' className='my-4'>
                    <Col xs={12}>
                      <LinkContainer
                        className='flex-center'
                        to={routes.app.accountSettings(
                          tabKeys.accountSettings.paymentDetail
                        )}
                      >
                        <Button className='flex-center'>
                          Reactivate your account to modify
                        </Button>
                      </LinkContainer>
                    </Col>
                  </Row>
                )}
                {isTeamReview ? (
                  <Row className='my-4'>
                    <Col xs={12}>
                      <Button
                        bsStyle='plain'
                        className='full'
                        onClick={(e) => goBack()}
                      >
                        Return to List
                      </Button>
                    </Col>
                  </Row>
                ) : (
                  <Row className='my-4'>
                    <Col xs={12}>
                      <Button
                        bsStyle='plain'
                        className='full'
                        onClick={(e) => {
                          if (backRoute) {
                            goTo(backRoute);
                          } else {
                            goTo(routes.app.professionalProfile.root);
                          }
                        }}
                      >
                        {isCreate ? 'Cancel' : 'Close'}
                      </Button>
                    </Col>
                  </Row>
                )}
              </Tab>
              <Tab
                eventKey='history'
                title={[
                  <span key={0}>History</span>,
                  <span
                    key={1}
                    className='activeArrow'
                    onClick={toggleDropdownOpen}
                  >
                    <i className='icon-chevron-down-large' />
                  </span>
                ]}
              >
                <ExternalCpdHistoryTable
                  history={externalCpdHistory}
                  rejectedText={
                    isBusinessUser(currentUser) || isTeamReview
                      ? 'Rejected'
                      : 'Draft'
                  }
                />
              </Tab>
            </Tabs>
          </form>
        </Col>
      </Row>
    </Grid>
  );
};

const defaultCpdCategory = {
  cpdCategoryId: null,
  points: 0,
  isMicroCpd: false,
  untouched: true
};

var detailsMap;

const initDetailsMap = (eventType, cpdCategorys, externalCpdForEdit) => ({
  activityName: {
    defaultValue: '',
    validation: {
      message: 'Activity Name is required'
    }
  },
  providerName: {
    defaultValue: '',
    validation: {
      message: 'Provider Name is required'
    }
  },
  users: {
    defaultValue: [],
    validation: {
      isValid: (arr) => fp.flow(fp.size, fp.gt(_, 0))(arr),
      message: 'At least one user is required'
    }
  },
  contentType: {
    defaultValue: externalActivityType.Other,
    validation: {
      message: 'Activity Type is required'
    }
  },
  timeEarned: {
    defaultValue: undefined,
    validation: {
      message: 'Date Earned is required'
    }
  },
  cpdCategorys: {
    arrayValues: {
      defaultValue: defaultCpdCategory,
      validation: {
        cpdCategoryId: {
          message: 'CPD Category is required'
        },
        points: {
          isValid: (v) =>
            eventType === PublishedEventTypes.Course ? true : fp.gt(v, 0),
          message: 'Must be more than 0'
        }
      }
    },
    defaultValue: [defaultCpdCategory],
    validation: {
      isValid: (arr) => {
        const unspecifiedCpdCategorys = fp.filter(
          ({ name }) => name === 'Pending'
        )(cpdCategorys);
        const unspecifiedCpdCategorySelected = fp.any(({ cpdCategoryId }) =>
          fp.contains(cpdCategoryId)(fp.map('id')(unspecifiedCpdCategorys))
        )(arr);
        return (
          fp.size(fp.uniqBy('cpdCategoryId')(arr)) === fp.size(arr) &&
          fp.flow(fp.size, fp.gt(_, 0))(arr) &&
          (!unspecifiedCpdCategorySelected || !externalCpdForEdit)
        );
      },
      message: 'CPD Categories must be present, specified and unique'
    }
  },
  notes: {
    defaultValue: ''
  },
  link: {
    defaultValue: ''
  },
  description: {
    defaultValue: ''
  },
  isTasaCpd: {
    defaultValue: false
  },
  accreditationNumber: {
    defaultValue: ''
  },
  modeOfLearning: {
    defaultValue: null,
    validation: {
      message: 'Type of CPD is required'
    }
  },
  typeOfCpd: {
    defaultValue: null,
    validation: {
      message: 'Type of CPD is required'
    }
  },
  goals: {
    defaultValue: []
  },
  files: {
    arrayValues: {
      defaultValue: null
    },
    defaultValue: [{}]
  },
  additionalData: {
    defaultValue: {
      accreditationDetails: []
    }
  }
});

const isValid = (args) =>
  fp.flow(fp.getOr(fp.identity)('isValid'), spreadArgs(args), toBoolean);

const getValidation = (details, eventType, cpdCategorys, externalCpdForEdit) =>
  fp.flow(
    fp.toPairs,
    fp.map(([key, { arrayValues, validation }]) => [
      key,
      fp.flow(
        arrayValues
          ? fp.assign({
              arrayValues: fp.flow(
                fp.get(key),
                noCapMap((x, i) => ({
                  ...noCapMapValues((validation, key) => ({
                    valid: isValid([fp.get(key)(x), i, x, details])(validation),
                    message: validation.message
                  }))(arrayValues.validation)
                }))
              )(details)
            })
          : fp.identity
      )(
        validation
          ? {
              valid: isValid(fp.over([fp.get(key), fp.identity])(details))(
                validation
              ),
              message: validation.message
            }
          : null
      )
    ]),
    fp.filter(fp.flow(fp.get('[1]'), fp.identity)),
    fp.fromPairs
  )(initDetailsMap(eventType, cpdCategorys, externalCpdForEdit));

const updateDetailsForEvent = ({
  eventToRegister,
  publishers,
  details,
  setDetail,
  currentUser,
  teamMembers,
  onUserSelected,
  business
}) => {
  const eventCpdCategory = eventToRegister.cpdCategorys.map(
    ({ cpdCategoryId, cpdPoints }) => ({
      cpdCategoryId,
      points: cpdPoints,
      isMicroCpd: false
    })
  );
  const eventPublisher = fp.flow(
    fp.filter(({ id }) => id === eventToRegister.publisherId),
    fp.first
  )(publishers);
  const detailCpdCategory = details.cpdCategorys;

  if (
    isBusinessAdmin(currentUser) ||
    isManager(currentUser) ||
    isTeamManager(currentUser, business)
  ) {
    const adminUser = fp.find(({ user: { id } }) => id === currentUser.id)(
      teamMembers
    );
    if (!fp.includes(adminUser)(details.users)) {
      onUserSelected(adminUser);
    }
  }

  if (JSON.stringify(eventCpdCategory) !== JSON.stringify(detailCpdCategory)) {
    setDetail('cpdCategorys', eventCpdCategory);
  }
  if (JSON.stringify(details.goals) !== JSON.stringify(eventToRegister.goals)) {
    setDetail('goals', eventToRegister.goals);
  }
  if (details.eventType !== eventToRegister.eventType) {
    setDetail('eventType', eventToRegister.eventType);
  }
  if (details.link !== eventToRegister.link) {
    setDetail('link', eventToRegister.link);
  }
  if (details.activityName !== eventToRegister.title) {
    setDetail('activityName', eventToRegister.title);
  }
  if (eventPublisher.name !== details.providerName) {
    setDetail('providerName', eventPublisher.name);
  }
  if (details.timeEarned !== eventToRegister.dateTimeOfEvent) {
    setDetail('timeEarned', eventToRegister.dateTimeOfEvent);
  }
  if (details.isTasaCpd !== eventToRegister.isTasaCpd) {
    setDetail('isTasaCpd', eventToRegister.isTasaCpd);
  }
  if (eventToRegister.eventType === PublishedEventTypes.Course) {
    setDetail('contentType', externalActivityType.Course);
  } else {
    if (eventToRegister.suburb === 'Online') {
      if (details.contentType !== externalActivityType.Webinar) {
        setDetail('contentType', externalActivityType.Webinar);
      }
    } else {
      if (details.contentType !== externalActivityType.Event) {
        setDetail('contentType', externalActivityType.Event);
      }
    }
  }
};

/**
 * Get the workflow user for current user to determine the workflow buttons of the external cpd form.
 * TODO (CADDIE-382): Improve the logic to make it more readable.
 *
 * @param {*} currentUser current logged in user.
 * @param {*} business the business of current user.
 * @param {*} userToFetch the user that current external cpd belong to, will be undefined if current user is creating new external cpd or reviewing self external cpd.
 * @param {*} isCreate if current user is creating new external cpd.
 * @param {*} isTeamReview if the current user is reviewing external cpd for team member.
 * @returns the workflow user for current user.
 */
const getWorkFlowUser = (
  currentUser,
  business,
  userToFetch,
  isCreate,
  isTeamReview
) => {
  const isBusinessAdminOrManager =
    isBusinessAdmin(currentUser) || isManager(currentUser);
  const isTeamManagerForBusiness = isTeamManager(currentUser, business);
  const isBusinessUserOrExternal =
    isBusinessUser(currentUser) || isExternalBusinessUser(currentUser);
  const isUserCanUploadWithoutApproval =
    business !== undefined && business.uploadCpdWithoutApproval !== undefined
      ? business.uploadCpdWithoutApproval
      : false;

  // Only the business admin, training plan manager, team manager (not for self) can directly approve cpd activity when creating.
  if (
    (isBusinessAdminOrManager ||
      isUserCanUploadWithoutApproval ||
      isTeamManagerForBusiness) &&
    isCreate
  ) {
    return 'BusinessAdmin';
  }
  // When business admin is reviewing self external cpd.
  else if (
    (isBusinessAdminOrManager || isUserCanUploadWithoutApproval) &&
    !userToFetch
  ) {
    return 'IndividualUser';
  }
  // Only the business admin, training plan manager, team manager (not for self) can review and approve pending cpd activity.
  else if (
    isBusinessAdminOrManager ||
    isUserCanUploadWithoutApproval ||
    (isTeamManagerForBusiness && userToFetch !== currentUser.id && isTeamReview)
  ) {
    return 'BusinessAdmin';
  } else if (isBusinessUserOrExternal) {
    return 'BusinessUser';
  } else {
    return 'IndividualUser';
  }
};

export default compose(
  withProps(
    ({
      match: {
        params: { userId, externalCpdId, eventId }
      }
    }) => ({
      externalCpdToFetch: parseInt(externalCpdId, 10),
      userToFetch: parseInt(userId, 10),
      eventToFetch: parseInt(eventId, 10),
      isCreate: !externalCpdId,
      isTeamReview: userId !== undefined,
      showSubmissionMessage: false,
      focusMessage: false
    })
  ),
  defaultProps({
    externalCpd: fp.mapValues(fp.get('defaultValue'))(initDetailsMap())
  }),
  connect(
    (state, { eventToFetch }) => ({
      currentUser: currentUserSelector(state),
      profile: state.user.profile,
      business: businessSelector(state),
      externalCpdForEdit: externalCpdForEditSelector(state),
      isFetchingExternalCpdForEdit: isFetchingExternalCpdForEditSelector(state),
      externalCpdForReview: externalCpdForReviewSelector(state),
      isFetchingExternalCpdForReview:
        isFetchingExternalCpdForReviewSelector(state),
      isFetchingEvent: state.event.isFetching,
      eventToRegister: eventToFetch ? state.event.selectedEvent : undefined,
      eventForEdit: eventToFetch ? undefined : state.event.selectedEvent,
      isFetchingPublisher: state.publisher.isFetching,
      publishers: state.publisher.publishers,
      industryCpdCategorys: state.industry.cpdCategorys,
      industriesWithCpdCategorys: state.industry.industriesWithCpdCategorys,
      allCpdCategorys: state.cpdCategorys.cpdCategorys,
      isLoading:
        state.externalCpd.request.add.isFetching ||
        isFetchingExternalCpdForReviewSelector(state),
      config: contentConfigSelector(state),
      teamExternalCpdError: state.business.externalCpdError,
      externalCpdError: state.externalCpd.error,
      includeTasa:
        fp.filter((industry) => industry.includeTasa)(
          currentUserIndustry(state)
        ).length > 0,
      teamMembers: fp.get('teamMembers')(queryTeamMembersSelector(state)),
      systemProfile: state.systemStatus.profile,
      userIndustry: currentUserIndustry(state)
    }),
    (dispatch) => ({
      goTo: bindActionCreators(push, dispatch),
      goBack: bindActionCreators(goBack, dispatch),
      getEvent: bindActionCreators(eventActions.event.getById, dispatch),
      getPublishers: bindActionCreators(
        publisherActions.publishers.get,
        dispatch
      ),
      saveDetails: bindActionCreators(
        externalCpdActions.externalCpd.add,
        dispatch
      ),
      updateDetails: bindActionCreators(
        externalCpdActions.externalCpd.update,
        dispatch
      ),
      getDetails: bindActionCreators(
        externalCpdActions.externalCpd.get,
        dispatch
      ),
      deleteExternalCpd: bindActionCreators(
        externalCpdActions.externalCpd.deleteExternalCpd,
        dispatch
      ),
      saveDetailsForBusinessUser: bindActionCreators(
        businessActions.business.user.addExternalCpd,
        dispatch
      ),
      updateDetailsForBusinessUser: bindActionCreators(
        businessActions.business.user.updateExternalCpd,
        dispatch
      ),
      getDetailsForBusinessUser: bindActionCreators(
        businessActions.business.user.getExternalCpd,
        dispatch
      ),
      deleteBusinessUserCpd: bindActionCreators(
        businessActions.business.user.deleteExternalCpd,
        dispatch
      ),
      queryTeamMembers: bindActionCreators(
        businessActions.business.queryTeamMembers,
        dispatch
      )
    })
  ),
  withProps(
    ({ industryCpdCategorys, allCpdCategorys, externalCpdForEdit }) => ({
      eventInvalid: fp.flow(
        fp.map(({ cpdCategoryId }) =>
          fp.find(({ id }) => id === cpdCategoryId)(industryCpdCategorys)
        ),
        fp.contains(undefined)
      )(externalCpdForEdit ? externalCpdForEdit.cpdCategoryPoints : []),
      eventCpdCategory: fp.map(({ cpdCategoryId }) =>
        fp.find(({ id }) => id === cpdCategoryId)(allCpdCategorys)
      )(externalCpdForEdit ? externalCpdForEdit.cpdCategoryPoints : [])
    })
  ),
  withProps(({ eventCpdCategory, eventInvalid, industryCpdCategorys }) => {
    // Filter out the event cpd categorys that are already in industry cpd categorys
    // If we want to include some specific attributes from event cpd categorys to cpd categorys, ..
    // .. we need to manually merge the attributes based on cpd category id from event and industry cpd categorys.
    const notInIndustryCategorysEventCpdCategory = eventCpdCategory.filter(
      ({ id }) => !fp.contains(id)(fp.map('id')(industryCpdCategorys))
    );
    return {
      cpdCategorys: industryCpdCategorys.concat(
        notInIndustryCategorysEventCpdCategory
      )
    };
  }),
  withProps(({ cpdCategorys }) => {
    return {
      cpdCategorys: attachFullNameAndRemoveParent(cpdCategorys)
    };
  }),
  withStateHandlers(
    {
      isDropdownOpen: false,
      dropDownSelectedKey: 'detail'
    },
    {
      selectDropDown:
        ({ isDropdownOpen, dropDownSelectedKey }) =>
        (key) => {
          return {
            isDropdownOpen:
              key === dropDownSelectedKey ? isDropdownOpen : false,
            dropDownSelectedKey:
              key !== dropDownSelectedKey ? key : dropDownSelectedKey
          };
        },
      toggleDropdownOpen:
        ({ isDropdownOpen }) =>
        (e) => {
          e.preventDefault();
          e.stopPropagation();
          return {
            isDropdownOpen: !isDropdownOpen
          };
        }
    }
  ),
  withProps(
    ({
      externalCpd,
      currentUser,
      isCreate,
      isTeamReview,
      eventToFetch,
      externalCpdForEdit,
      externalCpdForReview,
      isFetchingExternalCpdForEdit,
      isFetchingExternalCpdForReview,
      teamExternalCpdError,
      externalCpdError,
      business
    }) => ({
      externalCpdForEdit: isTeamReview
        ? externalCpdForReview
        : externalCpdForEdit,
      isFetchingExternalCpdForEdit: isTeamReview
        ? isFetchingExternalCpdForReview
        : isFetchingExternalCpdForEdit,
      externalCpd: {
        ...externalCpd,
        publishedEventId: eventToFetch,
        users: !isCreate
          ? [currentUser]
          : isBusinessAdmin(currentUser) ||
              isManager(currentUser) ||
              isTeamManager(currentUser, business)
            ? []
            : [currentUser]
      },
      error: teamExternalCpdError ? teamExternalCpdError : externalCpdError
    })
  ),
  withProps(({ currentUser, externalCpdForEdit }) => ({
    isUserBusinessAdmin: isBusinessAdmin(currentUser),
    externalCpdHistory: externalCpdForEdit && externalCpdForEdit.history,
    eventToFetchForEdit: fp.get('externalCpd.publishedEventId')(
      externalCpdForEdit
    )
  })),
  withProps(({ eventToRegister, eventForEdit }) => ({
    eventType: fp.get('eventType')(
      eventToRegister ? eventToRegister : eventForEdit
    )
  })),
  withStateHandlers(
    ({
      externalCpd,
      isCreate,
      eventType,
      cpdCategorys,
      externalCpdForEdit
    }) => ({
      ...fp.flow(
        fp.over([
          fp.identity,
          (details) => getValidation(details, eventType, externalCpdForEdit)
        ]),
        ([details, validation]) => ({
          details: {
            ...details,
            files:
              isCreate && (!details.files || details.files.length === 0)
                ? [null]
                : details.files
          },
          validation
        })
      )({
        ...externalCpd,
        files: []
      }),
      submitted: false,
      formRef: undefined
    }),
    {
      setFormRef: () => (form) => ({
        formRef: form
      }),
      setDetails:
        (
          { details, validation },
          { eventType, cpdCategorys, externalCpdForEdit }
        ) =>
        (transform) =>
          fp.flow(
            transform,
            fp.over([
              fp.identity,
              (details) =>
                getValidation(
                  details,
                  eventType,
                  cpdCategorys,
                  externalCpdForEdit
                )
            ]),
            ([details, validation]) => ({
              details,
              validation
            })
          )(details),
      setSubmitted:
        ({ validation }) =>
        () => ({
          submitted: true
        }),
      onUserRemoved:
        ({ details }, { eventType }) =>
        (toRemove) => ({
          details: {
            ...details,
            users: fp.filter((t) => t.user.id !== toRemove.user.id)(
              details.users
            )
          },
          validation: getValidation(details, eventType)
        }),
      onUserSelected:
        ({ details }, { eventType }) =>
        (u) => ({
          teamSearchText: '',
          details: {
            ...details,
            users: fp.uniqBy(({ user }) => user.id)(fp.concat(u)(details.users))
          },
          validation: getValidation(details, eventType)
        }),
      searchUsers: () => (searchText) => ({
        teamSearchText: searchText
      }),
      updateValidation:
        ({ details }, { eventType, cpdCategorys, externalCpdForEdit }) =>
        () => ({
          validation: getValidation(
            details,
            eventType,
            cpdCategorys,
            externalCpdForEdit
          )
        })
    }
  ),
  withHandlers({
    // When current user cannot create external cpd for others, the report users structure is [{ id: 'user id'}].
    // When current user can create external cpd for others, the report users structure is [{ user: { id: 'user id'}}].
    // TODO (CADDIE-383): Investigate and improve the report users structure.
    usersContainsCurrentUser:
      ({ details, currentUser }) =>
      () =>
        fp.find((t) => (t.user ? t.user.id : t.id) === currentUser.id)(
          details.users
        )
  }),
  withProps(({ details }) => ({
    isAdditionalDataValid: details.additionalData.accreditationDetails
      .map(
        (accreditationDetail) =>
          validateAccreditationName(accreditationDetail.name) === undefined &&
          validateAccreditationNumber(accreditationDetail.number) ===
            undefined &&
          validatePoints(accreditationDetail.points) === undefined
      )
      .every(Boolean)
  })),
  withProps(({ validation, details, teamMembers, isAdditionalDataValid }) => ({
    reviewUserName: fp.map((t) => fullName(t.user))(
      fp.filter((t) => t.user.id === details.userId)(teamMembers)
    ),
    isValid:
      isAdditionalDataValid &&
      fp.overEvery([
        fp.flow(
          fp.values,
          fp.every(
            fp.overEvery([
              fp.overSome([fp.negate(fp.has('valid')), fp.get('valid')]),
              branchFuncs(
                fp.has('arrayValues'),
                fp.flow(
                  fp.get('arrayValues'),
                  fp.overSome([
                    fp.flow(fp.size, fp.eq(0)),
                    fp.every(
                      fp.flow(
                        fp.values,
                        fp.every(
                          fp.overSome([
                            fp.negate(fp.has('valid')),
                            fp.get('valid')
                          ])
                        )
                      )
                    )
                  ])
                ),
                fp.stubTrue
              )
            ])
          )
        )
      ])(validation)
  })),
  withProps(({ location: { search } }) => ({
    taskId: queryString.parse(search).taskId
  })),
  withProps(({ taskId }) => ({
    backRoute: taskId ? routes.app.tasks.view(taskId) : undefined
  })),
  withStateHandlers(
    () => ({
      show: false,
      stateTransition: undefined,
      eventToRegisterInitiated: false,
      eventValidationInitiated: false
    }),
    {
      showConfirmation: () => (stateTransition) => ({
        show: true,
        stateTransition: stateTransition
      }),
      onCancel: () => () => ({ show: false }),
      initEventToRegister: () => () => ({ eventToRegisterInitiated: true }),
      initEventValidation: () => () => ({ eventValidationInitiated: true })
    }
  ),
  withHandlers({
    addArrayValue:
      ({ details, setDetails }) =>
      (key, value) =>
        fp.flow(
          fp.get(key),
          fp.flow(
            value === undefined
              ? fp.get(`${key}.arrayValues.defaultValue`)
              : () => value,
            reargCurriedConcat
          )(detailsMap),
          fp.set(key),
          setDetails
        )(details),
    getValidation:
      ({ submitted, validation }) =>
      (key) =>
        branchFuncs(
          fp.overSome([() => !submitted, fp.get(`${key}.valid`)]),
          fp.noop,
          fp.get(`${key}.message`)
        )(validation),
    removeArrayValue:
      ({ details, setDetails }) =>
      (key, index) =>
        fp.flow(
          fp.get(key),
          noCapRemove((_, i) => i === index),
          fp.set(key),
          setDetails
        )(details),
    setDetail:
      ({ setDetails }) =>
      (key, value) =>
        fp.flow(fp.set(key), setDetails)(value),

    onSaveBusinessUserCPD:
      ({
        saveDetailsForBusinessUser,
        business,
        details,
        usersContainsCurrentUser,
        backRoute
      }) =>
      (initialStatus) => {
        saveDetailsForBusinessUser(
          business.id,
          // When current user cannot create external cpd for others, the report users structure is [{ id: 'user id'}].
          // When current user can create external cpd for others, the report users structure is [{ user: { id: 'user id'}}].
          // TODO (CADDIE-383): Investigate and improve the report users structure.
          fp.map((t) => (t.user ? t.user.id : t.id))(details.users),
          { status: initialStatus, ...details },
          details.cpdCategorys,
          details.goals,
          details.files,
          backRoute
            ? backRoute
            : usersContainsCurrentUser()
              ? routes.app.professionalProfile.root
              : routes.app.training.home
        );
      },
    onSaveTeamManagerCPD:
      ({
        saveDetailsForBusinessUser,
        business,
        currentUser,
        details,
        usersContainsCurrentUser,
        backRoute
      }) =>
      (selfInitialStatus, membersInitialStatus) => {
        const getBackRoute = (backRoute) => {
          if (backRoute) {
            return backRoute;
          } else if (usersContainsCurrentUser()) {
            return routes.app.professionalProfile.root;
          } else {
            return routes.app.training.home;
          }
        };

        const saveTeamManagerCPDBackRoute = getBackRoute(backRoute);

        saveDetailsForBusinessUser(
          business.id,
          fp.map((t) => t.user.id)(details.users),
          { status: membersInitialStatus, ...details },
          details.cpdCategorys,
          details.goals,
          details.files,
          saveTeamManagerCPDBackRoute,
          currentUser.id,
          selfInitialStatus
        );
      },

    onUpdateBusinessUserCPD:
      ({
        updateDetailsForBusinessUser,
        details,
        business,
        externalCpdForEdit,
        backRoute
      }) =>
      (newStatus, reason) => {
        updateDetailsForBusinessUser(
          business.id,
          externalCpdForEdit.externalCpd.userId,
          { ...details, status: newStatus, reason: reason },
          details.cpdCategorys,
          details.goals,
          details.files,
          backRoute
        );
      },
    onDeleteBusinessUserCPD:
      ({
        deleteBusinessUserCpd,
        externalCpdForReview,
        userToFetch,
        business,
        backRoute
      }) =>
      () => {
        deleteBusinessUserCpd(
          business.id,
          userToFetch,
          externalCpdForReview.externalCpd.id,
          backRoute
        );
      },
    onSaveIndividualUserCPD:
      ({ saveDetails, details, currentUser, backRoute }) =>
      (initialStatus) => {
        saveDetails(
          {
            status: initialStatus,
            ...details
          },
          details.cpdCategorys,
          details.goals,
          details.files,
          backRoute
        );
      },
    onUpdateIndividualUserCPD:
      ({ updateDetails, details, backRoute }) =>
      (newStatus) => {
        updateDetails(
          {
            ...details,
            status: newStatus
          },
          details.cpdCategorys,
          details.goals,
          details.files,
          backRoute
        );
      },
    onDeleteIndividualUserCPD:
      ({ details, deleteExternalCpd, externalCpdForEdit, backRoute }) =>
      () => {
        deleteExternalCpd(externalCpdForEdit.externalCpd.id, backRoute);
      },

    onConfirm:
      ({
        details,
        isValid,
        currentUser,
        business,
        saveDetails,
        saveDetailsForBusinessUser,
        updateDetailsForBusinessUser,
        usersContainsCurrentUser,
        externalCpdForEdit,
        setSubmitted,
        isCreate
      }) =>
      (stateTransition, reasonText) => {
        if (isValid) {
          stateTransition.performAction(reasonText);
        }
      }
  }),
  withHandlers({
    addFiles:
      ({ setDetail, addArrayValue }) =>
      (key, files) =>
        fp.flow(
          fp.map((file) => {
            addArrayValue('files');
            return file;
          }),
          noCapMap((file, id) => {
            setDetail(`files[${key + id}]`, file);
          })
        )(files)
  }),
  withProps(
    ({ currentUser, userToFetch, isCreate, business, isTeamReview }) => {
      const workflowUser = getWorkFlowUser(
        currentUser,
        business,
        userToFetch,
        isCreate,
        isTeamReview
      );
      return {
        workflowUser
      };
    }
  ),
  withProps(({ workflowUser, business, details, ...state }) => {
    const workflowButtons = fp.flow(
      fp.filter(
        (b) =>
          (business && details.status && b.show) ||
          (!business && details.status && b.show) ||
          (!details.status && b.show)
      ),
      fp.filter((b) =>
        b.validType
          ? b.validType(
              details.contentType,
              details.timeEarned ? new Date(details.timeEarned) : new Date(),
              details.eventType
            )
          : true
      )
    )(fp.get(workflowUser)(workflow({ ...state, business, details })));
    return {
      workflowButtons: workflowButtons
    };
  }),
  withProps(({ workflowButtons, eventInvalid, externalCpdForEdit }) => ({
    readOnlyForm: eventInvalid || fp.all((b) => b.readOnly)(workflowButtons)
  })),
  withHandlers({
    submitForm:
      ({
        details,
        currentUser,
        setSubmitted,
        isValid,
        showConfirmation,
        onConfirm,
        setDetail
      }) =>
      (stateTransition) => {
        setSubmitted(details);
        fp.flow(
          fp.get('cpdCategorys'),
          noCapMap((v, index) =>
            setDetail(`cpdCategorys[${index}].untouched`, false)
          )
        )(details);

        if (isValid) {
          if (stateTransition.confirmation) {
            showConfirmation(stateTransition);
          } else {
            onConfirm(stateTransition);
          }
        }
      }
  }),
  withStateHandlers(
    () => ({
      requiresDownload: false,
      isDownloading: false
    }),
    {
      setRequiresDownload: () => () => ({ requiresDownload: true }),
      clearRequiresDownload: () => () => ({ requiresDownload: false }),
      setIsDownloading: () => () => ({
        requiresDownload: false,
        isDownloading: true
      }),
      clearIsDownloading: () => () => ({
        requiresDownload: false,
        isDownloading: false
      }),
      showErrorMessage: () => () => ({
        showSubmissionMessage: true,
        focusMessage: true
      }),
      stopFocusingMessage: () => () => ({ focusMessage: false }),
      hideSubmissionMessage: () => () => ({ showSubmissionMessage: false })
    }
  ),
  withStateHandlers(
    {
      searchDebounce: undefined
    },
    {
      updateSearchDebounce: () => (searchDebounce) => ({
        searchDebounce
      })
    }
  ),
  withProps(({ teamSearchText, currentUser }) => ({
    teamMemberFilter: {
      tags: teamSearchText,
      searchTeamNames: true,
      teamIds:
        isBusinessAdmin(currentUser) || isManager(currentUser)
          ? undefined
          : fp.flow(
              fp.get('teamMemberRoles'),
              fp.map((teamMemberRole) => teamMemberRole.businessTeamId),
              fp.join(',')
            )(currentUser)
    }
  })),
  lifecycle({
    componentDidMount() {
      const {
        isCreate,
        setRequiresDownload,
        externalCpdForEdit,
        externalCpdToFetch,
        setDetail,
        cpdCategorys,
        queryTeamMembers,
        business,
        teamMemberFilter,
        currentUser
      } = this.props;

      if (!detailsMap) {
        detailsMap = initDetailsMap();
      }

      if (
        business &&
        (isBusinessAdmin(currentUser) ||
          isManager(currentUser) ||
          isTeamManager(currentUser, business))
      ) {
        queryTeamMembers(business.id, teamMemberFilter);
      }

      if (
        externalCpdForEdit &&
        externalCpdForEdit.externalCpd.id === externalCpdToFetch
      ) {
        fp.map((k) => setDetail(k, fp.get(k)(externalCpdForEdit.externalCpd)))(
          fp.keys(externalCpdForEdit.externalCpd)
        );
        setDetail('cpdCategorys', externalCpdForEdit.cpdCategoryPoints);
        setDetail('existingFiles', externalCpdForEdit.files);
      } else if (!isCreate) {
        setRequiresDownload();
      }

      if (cpdCategorys.length > 0) {
        const defaultCoreCpdCategoryId = fp.flow(
          fp.filter(
            (category) => category.categoryType === cpdCategoryType.core
          ),
          fp.sortBy((aoa) => aoa.name),
          fp.first
        )(cpdCategorys).id;
        const defaultCpdCategory = {
          cpdCategoryId: defaultCoreCpdCategoryId,
          points: 0,
          isMicroCpd: false,
          untouched: true
        };
        setDetail('cpdCategorys', [defaultCpdCategory]);
        detailsMap.cpdCategorys.arrayValues.defaultValue = defaultCpdCategory;
      }
    },
    componentDidUpdate() {
      const { details, setDetail, systemProfile } = this.props;

      syncCpdCategoryWithGoals(
        details,
        (updatedGoals) => setDetail('goals', updatedGoals),
        systemProfile
      );
    },
    componentWillReceiveProps({
      requiresDownload,
      externalCpdForEdit,
      isFetchingExternalCpdForEdit,
      error: newError,
      details: newDetails,
      teamMemberFilter: nextTeamMemberFilter,
      ...nextProps
    }) {
      const {
        externalCpdToFetch,
        userToFetch,
        business,
        getDetailsForBusinessUser,
        getDetails,
        setDetail,
        clearRequiresDownload,
        setIsDownloading,
        clearIsDownloading,
        isDownloading,
        isTeamReview,
        error,
        showErrorMessage,
        onCancel,
        getEvent,
        eventToFetch,
        eventToRegister,
        isFetchingEvent,
        publishers,
        isFetchingPublisher,
        getPublishers,
        details,
        eventToRegisterInitiated,
        initEventToRegister,
        eventForEdit,
        eventToFetchForEdit,
        updateValidation,
        initEventValidation,
        eventValidationInitiated,
        queryTeamMembers,
        teamMemberFilter,
        updateSearchDebounce,
        searchDebounce,
        onSaveBusinessUserCPD,
        onSaveIndividualUserCPD,
        cpdCategorys
      } = this.props;

      if (!fp.isEqual(teamMemberFilter)(nextTeamMemberFilter)) {
        if (business) {
          const debounced = fp.debounce(500)(() => {
            queryTeamMembers(business.id, nextTeamMemberFilter);
          });
          updateSearchDebounce(debounced);
          searchDebounce && searchDebounce.cancel();
          debounced();
        }
      }

      if (
        !isFetchingExternalCpdForEdit &&
        requiresDownload &&
        userToFetch &&
        business &&
        business.id &&
        isTeamReview
      ) {
        setIsDownloading();
        getDetailsForBusinessUser(business.id, userToFetch, externalCpdToFetch);
      }

      if (!isFetchingExternalCpdForEdit && requiresDownload && !isTeamReview) {
        setIsDownloading();
        getDetails(externalCpdToFetch);
      }

      if (eventToFetch && !eventToRegister && !isFetchingEvent) {
        getEvent(eventToFetch);
      }

      if (eventToRegister) {
        if (publishers.length === 0 && !isFetchingPublisher) {
          getPublishers();
        }
        if (publishers.length > 0 && !eventToRegisterInitiated) {
          if (JSON.stringify(details) === JSON.stringify(newDetails)) {
            updateDetailsForEvent(this.props);
            initEventToRegister();
          }
          const unspecifiedCpdCategorys = fp.filter(
            ({ name }) => name === 'Pending'
          )(cpdCategorys);
          const unspecifiedCpdCategoryIds = fp.map('id')(
            unspecifiedCpdCategorys
          );
          const selectedCpdCategoryIds = fp.map('cpdCategoryId')(
            newDetails.cpdCategorys
          );
          const cpdPointsUnspecified = fp.some((id) =>
            fp.contains(id)(unspecifiedCpdCategoryIds)
          )(selectedCpdCategoryIds);
          if (nextProps.eventToRegisterInitiated && cpdPointsUnspecified) {
            if (business) {
              onSaveBusinessUserCPD(cpdPointStatus.registered);
            } else {
              onSaveIndividualUserCPD(cpdPointStatus.registered);
            }
          }
        }
      }

      if (eventToFetchForEdit && !eventForEdit && !isFetchingEvent) {
        getEvent(eventToFetchForEdit);
      }

      if (eventForEdit && !eventValidationInitiated) {
        updateValidation();
        initEventValidation();
      }

      if (
        !isFetchingExternalCpdForEdit &&
        externalCpdForEdit &&
        externalCpdForEdit.externalCpd.id === externalCpdToFetch &&
        isDownloading
      ) {
        fp.map((k) => setDetail(k, fp.get(k)(externalCpdForEdit.externalCpd)))(
          fp.keys(externalCpdForEdit.externalCpd)
        );
        setDetail('cpdCategorys', externalCpdForEdit.cpdCategoryPoints);
        setDetail('goals', externalCpdForEdit.goals);
        setDetail('existingFiles', externalCpdForEdit.files);
        clearRequiresDownload();
        clearIsDownloading();
      }

      if (!error && newError) {
        onCancel();
        setTimeout(showErrorMessage, 500);
      }
    }
  }),
  followedBy(
    0,
    ({
      currentUser,
      details: { users, contentType },
      planId,
      onCancel,
      onConfirm,
      onShow,
      show,
      smallTeamPlanId,
      teamMembers,
      isCreate,
      stateTransition,
      reviewUserName,
      isLoading
    }) => [
      <CreateModal
        {...{
          key: 1,
          currentUser,
          users,
          contentType:
            contentType === externalActivityType.Course ? 'course' : 'event',
          onCancel,
          onConfirm,
          onShow,
          show,
          stateTransition,
          reviewUserName,
          isLoading
        }}
      />
    ]
  ),
  branch(
    ({ requiresDownload, isDownloading }) => requiresDownload || isDownloading,
    renderComponent(() => <Loading />)
  ),
  branch(
    ({ eventToFetch, eventToRegisterInitiated }) =>
      eventToFetch && !eventToRegisterInitiated,
    renderComponent(Loading)
  ),
  branch(({ externalCpdToFetch, externalCpdForEdit }) => {
    return externalCpdToFetch && !externalCpdForEdit;
  }, renderComponent(Loading)),
  withStateHandlers(
    ({ externalCpdForEdit }) => ({
      inEditMode: externalCpdForEdit
        ? externalCpdForEdit.externalCpd.status !== cpdPointStatus.pending
        : true
    }),
    {
      toggleEditMode:
        ({ inEditMode }) =>
        () => ({ inEditMode: !inEditMode })
    }
  ),
  withProps(({ readOnlyForm, inEditMode }) => ({
    readOnlyForm: !inEditMode && readOnlyForm
  }))
)(ExternalCpdDetails);



// WEBPACK FOOTER //
// ./src/containers/pages/app/external-cpd/details.js